import { render, staticRenderFns } from "./addenMaterial.vue?vue&type=template&id=13d2f26e&scoped=true"
import script from "./addenMaterial.vue?vue&type=script&lang=js"
export * from "./addenMaterial.vue?vue&type=script&lang=js"
import style0 from "./addenMaterial.vue?vue&type=style&index=0&id=13d2f26e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d2f26e",
  null
  
)

export default component.exports